import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.responsibleConsumption.fields.id'),
  },
  {
    name: 'message',
    label: i18n('entities.responsibleConsumption.fields.message'),
  },
  {
    name: 'images',
    label: i18n('entities.responsibleConsumption.fields.images'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.responsibleConsumption.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.responsibleConsumption.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
